import { Component, OnInit, HostListener, ElementRef, ViewChild, EventEmitter, Output, Input, inject, computed } from '@angular/core';
import { Router } from '@angular/router';
import { faBars } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../../shared/navigation/nav.route.interface';
import { SecurityService } from '../../../core/security/security.service';
import { UserJsVm } from '../../../shared/generated/Admin/Models/User/JavaScript/UserJsVm';
import { NavigationService, NavDividerCharacter } from '../../../shared/navigation/navigation.service';
import { pcgSettings } from '../../../shared/generated/pcg-settings';
import { GlobalService } from '../../../shared/services/global.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';

@Component({
    selector: 'pcg-header'
    , templateUrl: './header.component.html'
    , styleUrls: ['./header.component.scss']
    , standalone: false
})
export class TopHeaderComponent implements OnInit {
	
    navService = inject(NavigationService);
    private sec = inject(SecurityService);
    private router = inject(Router);
    private gvs = inject(GlobalVariablesService);
    
	@ViewChild('userNav') userNav!: ElementRef;
	@ViewChild('mainHamburger', { static: true }) mainHamburger!: ElementRef;

	@Input() tabPanel: any;
    @Input() onChangePasswordScreen!: boolean;

	@Output() hamburgerClick = new EventEmitter<boolean>();

	user!: UserJsVm;
	
	navRoutes!: NavRoute[];
	currSelectedNavMenu!: NavRoute;

	currForceSelect!: string;
	currMainNavMenu!: string;
	mode = pcgSettings.mode;	
	navDividerCharacter = NavDividerCharacter;

	userNavOpen = false;
	adminAccess = false;
	isMobile!: boolean;
    isLoggedOn!: boolean;
	isNavFixed!: boolean;
	loading = false;

	navigationOffset = 0;

	faBars = faBars;

	@HostListener('window:resize') onResize() { this.isMobile = GlobalService.setIsMobile(window.innerWidth); }

	// Close the main navigation when they click outside of it
	// and are not clicking the mobile hamburger button
	@HostListener('document:click', ['$event']) clickDoc(event: any) {
		if (
			!this.mainHamburger?.nativeElement.contains(event.target) 
			&& !this.userNav?.nativeElement.contains(event.target)
		) {
			this.navService.setCurrOpenNavMenu('');
			this.userNavOpen = false;
		}
	}

	// Open search when they hit the '/' (or '`') key
	@HostListener('document:keydown', ['$event']) onKeydown(event: KeyboardEvent) {
		if (
			(
				event.key === '/' 
				|| event.key === '`'
			) 
			&& !this.isFormField(event.target)
		) { event.preventDefault(); }
	}

	ngOnInit() {
		this.isMobile = GlobalService.setIsMobile(window.innerWidth);
		this.sec.user$.subscribe(user => { this.user = user; });
		setTimeout(() => {
			let secondaryNav = document.getElementById("secondaryNav");
			if (secondaryNav != null) { secondaryNav.scrollLeft = Number(localStorage?.getItem("subNavPosition")); }
		}, 250);

		localStorage.getItem("isNavFixed") === "true" 
			? this.isNavFixed = true 
			: this.isNavFixed = false;
	}

    ngDoCheck() { this.isLoggedOn = this.sec.isLoggedOn(); }	//Needed to check if user is logged in (to toggle header)
	setSubNavPosition() { localStorage.setItem("subNavPosition", document.getElementById("secondaryNav")?.scrollLeft?.toString()!); }
	toggleNav() { this.hamburgerClick.emit(true); } // Toggle whether or not the main navigation is open

    // Used in the keyup function belew to prevent bringing up the search if they are focused in a form field
	isFormField(e: any) {
		if (!(e instanceof HTMLElement)) { return false; }
		const t = e.nodeName.toLowerCase();
		const n = (e.getAttribute('type') || '').toLowerCase();
		return (
			'select' === t 
			|| 'textarea' === t 
			|| (
				'input' === t 
				&& 'submit' !== n 
				&& 'reset' !== n
			) 
			|| e.isContentEditable
		);
	}	

    setDynamicStyle(
		name: string
		, styles: string
	) {
		let dynamicStyle = document.getElementById(name);
		if (dynamicStyle) { document.head.removeChild(dynamicStyle); }
		dynamicStyle = document.createElement('style');
		dynamicStyle.id = name;
		dynamicStyle.innerHTML = styles;
		document.head.appendChild(dynamicStyle);
	}

    mainNavTitle = computed(() => {
		let name = this.navService.currNav()?.name;

		switch (name) {
			case "Edit User": { name = this.gvs.userName(); break; }
			default: { break; }
		}

		if (!(name?.length > 0)) { name = this.navService.currNav()?.name; }
		return name;
	});
}
